<template>
  <div class="mod-segment">
    <div class="segment">
      <span class="type">
        {{ segmentName }}
      </span>
      <span class="org-dst">
        {{ detail.segments[0].departureName }} ——— {{ detail.segments[0].arrivalName }}
      </span>
    </div>
    <div v-show="!selectedProduct">
      <calendar :segment="detail.segments[0]" :departure-date="departureDate" @change="onCanlendarChange"></calendar>
      <l-filter :segment="detail.segments[0]" :isJJC="isJJC"  @sort="onSort"></l-filter>
      <div v-if="!itinerarys || !itinerarys.length" class="empty">
        抱歉，根据您的查询条件，暂无可预订的航班或者座位已售完，您可以选择其他日期进行查询或者购买其他航线机票。
      </div>
      <div v-if="itinerarys && itinerarys.length && isAllHide" class="empty">
        您购买的是联程航班，为您查询不到相同航司的航班，请重新选择航班进行预订!
      </div>
      <template v-if="!loading && itinerarys && itinerarys.length">
        <div
          v-for="(itinerary, index) in itinerarys"
          :key="`${itinerary.orgDsts[0].flightNo}-${itinerary.orgDsts[0].departureTime}-${index}`"
        >
          <!-- NOTE: JD - 公示经济舱 基础运价 及 航班截载时间 -->
          <div v-show="!itinerary.isHide" v-if="airline === 'JD'" class="mod-info">
              <span v-if="itinerary.orgDsts?.[0]?.economyPrice">{{ `${ itinerary.itineraryType !=='CT' ? itinerary.orgDsts?.[0]?.airlineName : '' }经济舱全价：${ itinerary.orgDsts?.[0]?.economyPrice } 元` }}</span>
              <span v-if="itinerary.orgDsts?.[0]?.cutOffTime">{{ `${ itinerary.orgDsts?.[0]?.departureAirPortName }航班起飞前 ${ itinerary.orgDsts?.[0]?.cutOffTime } 分钟停止办理乘机手续` }}</span>
              <span v-else>航班截载时间以机场信息为准</span>
              <span v-if="itinerary.orgDsts?.length > 1">联程航班：{{ itinerary.orgDsts?.length }}个航班</span>
          </div>
          <itinerary
            v-show="!itinerary.isHide"
            :itinerary="itinerary"
            :isJJC="isJJC"
            :isTransfer="itinerary.isTransfer"
            :index="index"
            :offerIndex="offerIndex"
            :offerItemId="offerItemId"
            :segment="detail.segments[0]"
            :benefitRules="benefitRules"
            :boutiqueAirlineLabels="boutiqueAirlineLabels"
            :luggageTags="luggageTags"
            :labelPrices="labelPrices"
            itineraryType="normalFlight"
            @open="onOpen"
            @select="onSelect"
          >
          </itinerary>
        </div>
      </template>
      <div class="loading" v-if="loading">
        <a-spin></a-spin>
      </div>
    </div>
    <template v-if="selectedProduct">
      <choose
        :itinerary="itinerarys[openIndex]"
        :product="selectedProduct"
        :segment="detail.segments[0]"
        :isJJC="isJJC"
        :ifInternational="ifInternational"
        :isTransfer="itinerarys[openIndex]?.isTransfer"
        @cancel="onCancel"
      >
      </choose>
    </template>
    <a-modal
      v-model="validateGoVisible"
      :title="validateGoData.title"
      dialogClass="ant-modal-confirm ant-modal-confirm-confirm"
      :closable="false"
      :footer="null"
      :width="416"
    >
      <div class="ant-modal-confirm-body ant-modal-confirm-body-wrapper">
        <a-icon type="question-circle" />
        <span class="ant-modal-confirm-title">{{ validateGoData.title }}</span>
        <div class="ant-modal-confirm-content" v-html="validateGoData.content"></div>
        <div class="ant-modal-confirm-btns">
          <a-button key="back" @click="() => this.validateGoVisible = false">
            {{ validateGoData.cancelText }}
          </a-button>
          <a
            style="margin-left: 12px;"
            class="ant-btn ant-btn-primary"
            :href="validateGoData.url"
            @click="() => this.validateGoVisible = false"
            target="_blank"
          >
            {{ validateGoData.okText }}
          </a>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import Calendar from './Calendar'
import Filter from './FilterCross'
import Itinerary from './ItineraryCross'
import Choose from './Choose'
import '../css/flight.less'
import Observer from '@/assets/js/observer'
import { validateIsEnable } from '@/apis/flight'
import { getAirportValue } from '@/assets/js/util'
import { flightCities } from '@/assets/js/data'
import getAppInfo from '@/utils/from'
import { hanleItinerarys, sortItinerarys } from '../util'

const { airline } = window.__MICRO_ROOT__

export default {
  props: {
    criteria: Object,
    detail: Object,
    isJJC: Boolean,
    offerIndex: Number,
    loading: Boolean,
    selectedProducts: Array,
    ifInternational: Boolean,
    pageCmsData: Object
  },
  data () {
    return {
      departureDate: '',
      segmentName: '',
      offerItemId: '',
      openIndex: -1,
      selectedProduct: null,
      sortType: 'dateAsc',
      benefitRules: [],
      labelPrices: [],
      boutiqueAirlineLabels: [],
      luggageTags: [],
      validateGoData: {},
      validateGoVisible: false,
      airline,
      appInfo: getAppInfo(),
      itineraryType: 'normalFlight'
    }
  },
  async created () {
    const { detail, criteria, offerIndex } = this
    const segment = detail.segments[0]
    const itinerary = (detail.itinerarys && detail.itinerarys.length) ? detail.itinerarys[0].orgDsts[0] : null
    const { tripType, originDestinations } = criteria
    const departureDate = itinerary ? itinerary.departureDate : moment(originDestinations[offerIndex].flightDate).format('YYYY-MM-DD')
    this.departureDate = departureDate
    this.segmentName = await this.getSegmentName(tripType, originDestinations, segment, departureDate)
    this.cmsInit()
  },
  computed: {
    itinerarys () {
      const { detail, sortType, selectedProducts, offerIndex, ifInternational, airline } = this
      let list = hanleItinerarys(detail, ifInternational)

      // 按sortType进行排序
      list = sortItinerarys(list, sortType, airline)

      // 往返程、多程，筛选航班
      const compareItinerary = selectedProducts[offerIndex ? 0 : 1]
      if (compareItinerary) {
        const compareTime = offerIndex ? moment(`${compareItinerary.arrivalDate} ${compareItinerary.arrivalTime}`).add(2, 'h').valueOf() : moment(`${compareItinerary.departureDate} ${compareItinerary.departureTime}`).subtract(2, 'h').valueOf()
        list = _.map(list, item => {
          const orgDst = offerIndex ? item.orgDsts[0] : item.orgDsts[item.orgDsts.length - 1]
          const time = offerIndex ? moment(`${orgDst.departureDate} ${orgDst.departureTime}`).valueOf() : moment(`${orgDst.arrivalDate} ${orgDst.arrivalTime}`).valueOf()
          item.isHide = !(offerIndex ? time >= compareTime : time <= compareTime)

          return item
        })
      }

      const _selectedProducts = _.compact(selectedProducts)
      if (_selectedProducts.length) {
        const it = _selectedProducts[0]
        list = _.map(list, item => {
          if (!ifInternational) {
            item.isHide = item.orgDsts[0].airlineCode !== it.airlineCode
          } else {
            // 国际票往返程的 offerItemId 是唯一关联的，基于 groupOfferItemIdList 与 offerItemId 进行过滤
            item.isHide = !item.productPrices?.find(productPrice => {
              // return it.offerItemIds[0]?.groupOfferItemIdList?.indexOf(productPrice.detail?.offerItemId) > -1 ||
              // productPrice.detail?.groupOfferItemIdList?.indexOf(it.offerItemIds[0]?.offerItemId) > -1

              return _.intersection(it.offerItemIds[0]?.groupOfferItemIdList, productPrice.detail?.groupOfferItemIdList).length
            })
            if (!item.isHide) {
              item.cabins.forEach(cabin => {
                cabin.brands.forEach(brand => {
                  brand.products.forEach(product => {
                    // product.isHide = !(it.offerItemIds[0]?.groupOfferItemIdList?.indexOf(product.detail?.offerItemId) > -1 || product.detail?.groupOfferItemIdList?.indexOf(it.offerItemIds[0]?.offerItemId) > -1)
                    product.isHide = !_.intersection(it.offerItemIds[0]?.groupOfferItemIdList, product.detail?.groupOfferItemIdList).length
                  })
                  const isHideLength = brand.products.filter(item => item.isHide)?.length
                  if (brand.products.length === isHideLength) {
                    this.$set(brand, 'isHide', true)
                  }
                })
                const isHideLength = cabin.brands.filter(item => item.isHide)?.length
                if (cabin.brands.length === isHideLength) {
                  this.$set(cabin, 'isHide', true)
                }
              })
            }
          }

          return item
        })
      }

      return list
    },
    isAllHide () {
      const { itinerarys } = this
      let flag = false
      itinerarys.forEach(itinerary => {
        if (!itinerary.isHide) {
          flag = true
        }
      })
      return !flag
    }

  },
  methods: {
    cmsInit () {
      const { pageCmsData } = this
      // 获取cms价格标签配置
      this.labelPrices = _.get(pageCmsData, 'flight-label-price.list') || []
      // 获取cms权益配置
      this.benefitRules = _.get(pageCmsData, 'rights-configs.list') || []
      // 精品航线标识
      this.boutiqueAirlineLabels = _.get(this.pageCmsData, 'flight-boutique-airline-label.flightLabels') ?? []
      // 行李定制化标签
      this.luggageTags = _.get(this.pageCmsData, 'flight-luggage-tags.services') ?? []
    },
    async isEnableValidate (product, choose) {
      const checkProduct = { ...choose, ...product.detail.services[0] }
      const params = {
        argFlightNo: checkProduct.flightNo,
        argCabinCode: checkProduct.cabinCode,
        argDepCode: checkProduct.depCode,
        argArrCode: checkProduct.arrCode,
        argProductCode: checkProduct.productCode,
        argFlightDate: `${checkProduct.departureDate} ${checkProduct.departureTime}`
      }
      validateIsEnable(params).then(() => {
        this.$emit('select', this.offerIndex, choose, product, this.itineraryType)
      }).catch(err => {
        const { code, data } = err

        if (code === '-1' && data && data.length) {
          const observer = new Observer()
          observer.complete = () => {
            this.$emit('select', this.offerIndex, choose, product, this.itineraryType)
          }
          for (const item of data) {
            if (item.code === '100100') {
              // 错误提示
              observer.add(() => {
                this.$error({
                  title: item.title || '温馨提示',
                  okText: item.cancelText || '知道了',
                  content: h => item.message
                })

                return Promise.reject(new Error())
              })

              break
            } else if (item.code === '100200') {
              // 提示，可以进入下一步
              observer.add(() => {
                return new Promise((resolve, reject) => {
                  this.$confirm({
                    title: item.title || '温馨提示',
                    content: h => item.message,
                    okText: item.okText || '继续预订',
                    cancelText: item.cancelText || '知道了',
                    onOk: () => {
                      resolve()
                    },
                    onCancel: () => {
                      reject(new Error())
                    }
                  })
                })
              })
            } else if (item.code === '100300') {
              // 提示，下一步跳转链接
              observer.add(() => {
                this.validateGoData = {
                  title: item.title || '温馨提示',
                  content: item.message,
                  okText: item.okText || '继续预订',
                  cancelText: item.cancelText || '知道了',
                  url: item.url
                }
                this.validateGoVisible = true

                return Promise.reject(new Error())
              })

              break
            } else {
              // 未知类型
              observer.add(() => {
                this.$error({
                  title: item.title || '温馨提示',
                  okText: item.cancelText || '知道了',
                  content: h => item.message
                })

                return Promise.reject(new Error())
              })

              break
            }
          }

          if (observer.queue.length) {
            observer.start()
          }
        } else {
          this.$message.error(err.message || '网络异常，请稍后再试！')
        }
      })
    },
    // TODO: 中转航班不适用
    async getSegmentName (tripType, originDestinations, segment, departureDate) {
      const airport = await flightCities()

      if (tripType === 'ONEWAY') {
        return '去程'
      }
      const idx = _.findIndex(originDestinations, item => {
        return getAirportValue(item.depCode, airport) === getAirportValue(segment.departureCode, airport) && getAirportValue(item.arrCode, airport) === getAirportValue(segment.arrivalCode, airport) && moment(item.flightDate).format('YYYY-MM-DD') === departureDate
      })
      if (tripType === 'ROUNDTRIP') {
        return idx ? '返程' : '去程'
      }

      if (idx === -1) {
        return '-'
      }

      return `第 ${idx + 1} 程`
    },
    onCanlendarChange (value) {
      this.$emit('search', value, this.offerIndex)
    },
    onOpen (data) {
      const { value, index } = data
      this.offerItemId = value
      this.openIndex = index
    },
    onSelect (product, choose) {
      this.selectedProduct = product
      // this.$emit('select', this.offerIndex, choose, product)
      this.isEnableValidate(product, choose)
    },
    onCancel () {
      const { offerIndex, ifInternational } = this
      if (!ifInternational) {
        this.selectedProduct = null
        this.$emit('select', offerIndex, null, null, this.itineraryType)
      } else {
        this.$emit('cancelAll')
      }
    },
    onSort (sort) {
      this.sortType = sort
    }
  },
  filters: {},
  components: {
    Calendar,
    'l-filter': Filter,
    Itinerary,
    Choose
  }
}
</script>
